module.exports = __webpack_public_path__ + "public/images/debate-skills.838dac7a9c7e65bde43ee68c60ac4108.jpg";